import { apiClient } from './client';
import type {
  AssignOnDemandTrainingProgramRequest,
  AssignTrainingProgramRequest,
  TrainingProgramActivation,
} from '../types/api';

export const trainingProgramActivationApi = {
  async activate(programId: number, durationWeeks: number): Promise<TrainingProgramActivation> {
    return apiClient.post<TrainingProgramActivation>(`/v1/training-programs/${programId}/activate`, { durationWeeks });
  },

  async deactivate(programId: number): Promise<void> {
    return apiClient.delete<void>(`/v1/training-programs/${programId}/activate`);
  },

  async getHistory(): Promise<TrainingProgramActivation[]> {
    return apiClient.get<TrainingProgramActivation[]>('/v1/training-programs/activations');
  },

  async assignToTrainee(programId: number, request: AssignTrainingProgramRequest): Promise<TrainingProgramActivation> {
    return apiClient.post<TrainingProgramActivation>(`/v1/training-programs/${programId}/assign`, request);
  },

  async assignOnDemand(request: AssignOnDemandTrainingProgramRequest): Promise<TrainingProgramActivation> {
    return apiClient.post<TrainingProgramActivation>('/v1/training-programs/assign-on-demand', request);
  },

  async deassignFromTrainee(programId: number, traineeId: number): Promise<void> {
    return apiClient.delete<void>(`/v1/training-programs/${programId}/assign/${traineeId}`);
  },

  async getTraineeAssignmentHistory(traineeId: number): Promise<TrainingProgramActivation[]> {
    return apiClient.get<TrainingProgramActivation[]>(`/v1/training-programs/trainees/${traineeId}/assignments`);
  },

  async getTraineeActiveAssignment(traineeId: number): Promise<TrainingProgramActivation | null> {
    try {
      const result = await apiClient.get<TrainingProgramActivation>(`/v1/training-programs/trainees/${traineeId}/active-assignment`);
      return result?.id != null ? result : null;
    } catch {
      return null;
    }
  },
};
